<script lang="ts" setup>
import EmplacementName from './EmplacementName.vue';
import FuncLocation from './FuncLocation.vue';
import MachineName from './MachineName.vue';
import StoreName from './StoreName.vue';

defineProps<{
  machineName?: string | null;
  funcLocation?: string | null;
  storeName?: string | null;
  emplacement?: string | null;
}>();
</script>

<template>
  <span
    inline-flex
    items-center
    gap-1
  >
    <MachineName
      v-if="machineName"
      :name="machineName"
    />
    <FuncLocation
      v-if="funcLocation"
      :name="funcLocation"
    />

    <StoreName
      v-if="storeName"
      :name="storeName"
    />
    <EmplacementName
      v-if="emplacement"
      :name="emplacement"
    />
  </span>
</template>
